import React from 'react';
import PageContainer from '../../components/PageComponents/layouts/PageContainer';
import SafetyNav from '../../components/SafetyNav';
import List from './List';

const breadcrumbs = [{ label: 'Daily Safety Forms', isActive: true }];

const SafetyDailyForms = () => (
  <PageContainer heading="DAILY SAFETY FORMS" breadcrumbs={breadcrumbs}>
    <SafetyNav />
    <List />
  </PageContainer>
);

export default SafetyDailyForms;
